import './vacancy_apply_modal.scss'
import {Modal} from "antd";
import {InputGroup} from "../../input-group/inputGroup";
import {useEffect, useRef, useState} from "react";
import isEmail from "validator/es/lib/isEmail";
import {useTranslations} from "../../../../graphql/query.hooks/translation.hook";
import {LoadingOutlined} from "@ant-design/icons";
import {CheckIcon, FileUploadIcon, ModalCloseIcon, UploadSuccessIcon} from "../../../../assets/images";
import {Link} from "react-router-dom";
import {GetUrlWithLocal} from "../../../../utils/getUrlWithLocal";
import {APP_URLS} from "../../../../graphql/client";

function VacancyApplyModal(props) {
    const {closeModal, visible, vacancyId,vacancyCV} = props
    const translations = useTranslations()
    const imageSelector = useRef();

    const [fetchingStatus, setFetchingStatus] = useState('')
    const [fieldsData, setFieldsData] = useState({
        firstName: '',
        phone: '',
        email: '',
        file: null,
    })

    const [error, setError] = useState({
        firstName: false,
        phone: false,
        email: false,
        file: false,
    })

    useEffect(() => {
        if (visible) {
            document.body.classList.add("disable-scroll");
        } else {
            document.body.classList.remove("disable-scroll");
        }
        return () => {
            document.body.classList.remove("disable-scroll");
        }
    }, [visible])

    function handleImageChange(e) {
        const file = e.target.files?.[0];
        if (!file) return;

        console.log('file', file)
        setFieldsData({
            ...fieldsData,
            file: file
        })
        setError({
            ...error,
            file: false
        })
    }

    function selectFile() {
        imageSelector.current?.click();
    }

    function validate() {
        const newErrors = {};
        let valid = true;

        if (!fieldsData.firstName) {
            newErrors.firstName = true;
            valid = false;
        }

        if (!fieldsData.phone || !/^[+374]{4}[0-9]{8}$/.test(fieldsData.phone)) {
            newErrors.phone = true;
            valid = false;
        }

        if (!fieldsData.email || !isEmail(fieldsData.email)) {
            newErrors.email = true;
            valid = false;
        }

        if (vacancyCV && !fieldsData.file) {
            newErrors.file = true;
            valid = false;
        }

        setError(newErrors);
        return valid;
    }


    function getInputValues(e) {
        let {name, value} = e.target;
        if (name === "phone" && value && !/^[+\d]\d*$/.test(value)) {
            return
        }
        if (name === "phone" && value.length === 1 && value !== "+") {
            value = "+" + value
        }
        setFieldsData({
            ...fieldsData,
            [name]: value
        })
        setError({
            ...error,
            [name]: false
        })
    }

    const applyVacancy = async () => {
        const {firstName, phone, email, file} = fieldsData;
        if (validate()) {
            setFetchingStatus('loading');

            const applyFormData = new FormData();
            applyFormData.append('cv', file);
            applyFormData.append('name', firstName);
            applyFormData.append('email', email);
            applyFormData.append('phone', phone);

            await fetch(`${APP_URLS.vacancy_apply}/${vacancyId}`, {
                method: "POST",
                body: applyFormData,
            }).then((res) => {
                console.log('result', res)

                if(res.status === 201) {
                    setFetchingStatus('success')
                    setTimeout(() => {
                        closeModal()
                    }, 2000)
                }else{
                    setFetchingStatus('')
                }
            });
        }
    }

    return <Modal
        visible={visible}
        wrapClassName={'vacancy-apply-modal'}
        transitionName={""} // changed modal animation
        centered={true}
        closeIcon={<ModalCloseIcon/>}
        maskClosable={true}
        onCancel={closeModal}>
        <div className={'vacancy-apply-modal-wrapper'}>
            <div className={'vacancy-modal-header'}>
                <div className={'vacancy-modal-title'}>
                    {translations?.vacancy_modal_title}
                </div>
                <div className={'vacancy-modal-description'}>
                    {translations?.vacancy_modal_description}
                </div>
            </div>
            <div className={'vacancy-modals-inputs'}>
                <InputGroup
                    inputType={'input'}
                    type={"text"}
                    value={fieldsData.firstName}
                    error={error.firstName}
                    name={'firstName'}
                    placeholder={`${translations?.contacts_page_placeholder_name}`}
                    maxLength={100}
                    onChange={getInputValues}
                />
                <InputGroup
                    inputType={'input'}
                    type={"text"}
                    value={fieldsData.phone}
                    error={error.phone}
                    name={'phone'}
                    placeholder={`${translations?.contacts_page_placeholder_phoneNumber}`}
                    maxLength={12}
                    onChange={getInputValues}
                />
                <InputGroup
                    inputType={'input'}
                    type={"text"}
                    value={fieldsData.email}
                    error={error.email}
                    name={'email'}
                    placeholder={`${translations?.contacts_page_placeholder_email}`}
                    maxLength={100}
                    onChange={getInputValues}
                />
            </div>

            {vacancyCV && <div className={`upload_cv_wrapper ${error.file ? 'error' : ''}`} onClick={selectFile}>
                <div className={'upload_icon'}>
                    <FileUploadIcon/>
                </div>
                <div className={'upload_content'}>
                    <span className={'title'}>
                        {fieldsData.file ? fieldsData.file.name : translations?.vacancy_modal_attache_file}
                    </span>
                    <span className={'subTitle'}>
                        {fieldsData.file ? `${(fieldsData.file.size / 1024).toFixed(2)} KB` :
                            translations?.vacancy_modal_attache_file_types}
                    </span>
                    {fieldsData.file && <div className={'check_icon'}>
                        <CheckIcon/>
                    </div>}
                </div>
                <input
                    type="file"
                    accept={".doc, .pdf, .docx,"}
                    ref={imageSelector}
                    onChange={handleImageChange}
                    hidden
                />
            </div>}

            <div className={'privacy_police_wrapper'}>
                {translations?.vacancy_modal_privacy_policy_text}
                <Link to={GetUrlWithLocal('/privacy')}>
                    {translations?.vacancy_modal_privacy_policy_link}
                </Link>
            </div>
                 <button className='apply_button'
                                      onClick={applyVacancy}>
                    <span>{translations?.vacancy_modal_apply_btn}</span>
                    {fetchingStatus === "loading" && <LoadingOutlined style={{fontSize: 13, color: "#fff"}}/>}
                    {fetchingStatus === "success" && <UploadSuccessIcon/>}
                </button>
        </div>
    </Modal>
}

export default VacancyApplyModal
